import { action } from 'satcheljs';

export const deactivateHelpCharmAction = action('DEACTIVATE_HELP_CHARM');
